import type { ErrorBoundaryProps } from "./error-boundary.type";

import { isRouteErrorResponse } from "react-router";

import { debugE2E } from "@/config/environmentUtils";
import { PageError } from "@/modules/page-error";
import {
  PageErrorDevMode,
  shouldShowErrorToDeveloper,
} from "@/modules/page-error-dev-mode";

export const ErrorBoundary = ({ error }: ErrorBoundaryProps) => {
  if (isRouteErrorResponse(error)) {
    return <PageError status={error.status} />;
  }

  if (debugE2E() || shouldShowErrorToDeveloper()) {
    return <PageErrorDevMode error={error} />;
  }

  return <PageError />;
};
